import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const MexicoReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Apostille for Mexico:</h3>
        <p>
          Legalization for Mexico has its own importance in the visa process &
          expansion of the business in Mexico. There are policies of Mexico that
          need documents with the MEA sticker to sanction a visitor to enter
          their country. It is a part of the evidence that signifies the
          trustworthiness of the documents.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille for Mexico:</h3>
        <p>
          The time-span required for Apostille documents for Mexico depends on
          various reasons such as which state the certificate was issued from,
          or the sorts of documents, or the organization you need it from.
          Generally, it will take around a couple of weeks to 2-3 working days
          to accomplish the whole process of Mexico Apostille service in
          Bangalore for certificates.
        </p>
      </div>
    </div>
  );
};

export default MexicoReqMain;
